<template>
  <ion-page>
    <MyHeader title="プライバシーポリシー" />
    <ion-content :fullscreen="true" class="ion-padding">
      <p>
        マネーにっき（以下、「当サイト」）では、ユーザーからお預かりする個人情報の重要性を強く認識し、個人情報の保護に関する法律、その他の関係法令を遵守すると共に、以下に定めるプライバシーポリシーに従って、個人情報を安全かつ適切に取り扱うことを宣言いたします。
      </p>
      <h5>個人情報の内容</h5>
      <p>
        当サイトでは、会員情報の管理にFirebaseを利用しています。<br />
        当サイトのデータベースでは、ユーザーが入力した購入情報にまつわるデータの他、登録時に送信されたユーザー名とメールアドレスを保存しています。<br />
        Firebaseの利用規約については<a
          href="https://cloud.google.com/terms/?hl=ja"
          target="_blank"
          >https://cloud.google.com/terms/?hl=ja</a
        >をご確認ください。
      </p>
      <h5>個人情報の第三者提供</h5>
      <p>
        お客様からお預かりした個人情報を、個人情報保護法その他の法令に基づき開示が認められる場合を除き、ご本人様の同意を得ずに第三者に提供することはありません。
      </p>
      <h5>個人情報の開示・訂正・削除について</h5>
      <p>
        お客様からお預かりした個人情報の開示・訂正・削除をご希望の場合は、ご本人様よりお問い合わせください。適切な本人確認を行った後、速やかに対応させていただきます。
      </p>
      <h5>Cookie（クッキー）について</h5>
      <p>
        当サイトでは、広告配信に「Google Adsense」を利用しております。<br />
        Google
        Adsenseでは、Cookieを使用することにより、お客様の過去のアクセス情報に基づいて、適切な広告を配信する場合があります。<br />
        お客様はGoogle広告設定から、Cookieを使用したパーソナライズ広告を無効にすることができます。<br />
        なお、Cookieに保存されている情報からお客様個人を特定することはできません。
      </p>
      <p>
        Google広告の利用規約・ポリシーについては<a
          href="https://policies.google.com/technologies/ads?hl=ja"
          target="_blank"
          >https://policies.google.com/technologies/ads?hl=ja</a
        >をご確認ください。
      </p>
      <h5>アクセス解析ツールについて</h5>
      <p>
        当サイトではアクセス解析に「Google Analytics for
        Firebase」を利用しております。<br />
        Google
        Analyticsは、Cookieを使用することでお客様のトラフィックデータを収集しています。
      </p>
      <p>
        お客様はブラウザの設定でCookieを無効にすることで、トラフィックデータの収集を拒否することができます。<br />
        なお、トラフィックデータからお客様個人を特定することはできません。<br />
        Google Analytics for Firebase の利用規約については
        <a
          href="https://firebase.google.com/terms/analytics?hl=ja"
          target="_blank"
          >https://firebase.google.com/terms/analytics?hl=ja</a
        >
        をご確認ください。
      </p>
      <h5>本ポリシーの変更</h5>
      <p>
        当サイトは、法令の制定、改正、サービス内容の変更等により、本ポリシーを適宜見直し、予告なく変更する場合があります。本ポリシーの変更は、変更後の本ポリシーが当サイトに掲載された時点、またはその他の方法により変更後の本ポリシーが閲覧可能となった時点で有効になります。
      </p>
    </ion-content>
  </ion-page>
</template>

<script lang="ts">
import { IonPage, IonContent } from '@ionic/vue'
import { defineComponent } from 'vue'
import MyHeader from '@/components/layouts/MyHeader.vue'

export default defineComponent({
  components: {
    MyHeader,
    IonContent,
    IonPage,
  },
  setup() {
    return {}
  },
})
</script>

<style lang="scss" scoped>
p {
  font-size: 14px;
}
</style>
